import { render, staticRenderFns } from "./CategoryListPage.vue?vue&type=template&id=6d32b98e&"
import script from "./CategoryListPage.vue?vue&type=script&lang=js&"
export * from "./CategoryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports